// STATYSTYKA — DOMINANTA (MODA), jedna wyraźna moda, bez Σ
import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";

function shuffle(a){ for(let i=a.length-1;i>0;i--){ const j=Math.floor(Math.random()*(i+1)); [a[i],a[j]]=[a[j],a[i]]; } return a; }

// ========== GENERATOR ==========
export function generateTask() {
  const n = 9 + Math.floor(Math.random()*6); // 9..14
  const modal = 1 + Math.floor(Math.random()*9); // moda 1..9
  const modalCount = 3 + Math.floor(Math.random()*3); // 3..5 razy
  const restCount = n - modalCount;

  const values = [];
  for (let i=0;i<modalCount;i++) values.push(modal);
  while (values.length < n) {
    const v = 1 + Math.floor(Math.random()*9);
    if (v === modal) continue;
    // pilnuj, by żaden inny nie dogonił mody
    const c = values.filter(x=>x===v).length;
    if (c >= modalCount-1) continue;
    values.push(v);
  }
  shuffle(values);

  return {
    type: "ModeTask",
    data: { n, values, modal },
    uid: `mode_${Date.now()}_${Math.floor(Math.random()*1e9)}`
  };
}

// ========== TREŚĆ ==========
export function renderTask({ data }) {
  const list = data.values.join(",\\,");
  return (
    <div style={{textAlign:'left', lineHeight:1.6}}>
      <div>Podane dane: <InlineMath math={list} /><span>.</span></div>
      <div style={{marginTop:4}}>
        Oblicz <b>dominantę (modę)</b> <InlineMath math={'D'} /><span>.</span>
      </div>
    </div>
  );
}

// ========== INPUT ==========
export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-3" style={{marginTop:6}}>
      <span><InlineMath math={'D = '} /></span>
      <FractionInput value={userAnswer} onChange={onChange} disabled={disabled} label="D" placeholder="np. 7" />
    </div>
  );
}

// ========== CHECK ==========
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || !userAnswer.raw) return { correct:false, message:"Podaj dominantę." };
  const s = String(userAnswer.raw).trim().replace(",", ".");
  if (!/^[+-]?\d+(\.0+)?$/.test(s)) return { correct:false, message:"Podaj liczbę całkowitą." };
  const uv = Math.round(parseFloat(s));
  const correct = uv === data.modal;
  return { correct, expected: `D = ${data.modal}` };
}

// ========== ODPOWIEDŹ / PODGLĄD ==========
export function renderAnswer({ data }) { return <InlineMath math={`D = ${data.modal}`} />; }
export function renderUserAnswer(ans) {
  if (!ans || !ans.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(ans.raw, 'D')} />;
}

// ========== WYJAŚNIENIE ==========
export function renderExplanation({ data }) {
  const vals = data.values;
  const uniq = [...new Set(vals)].sort((a,b)=>a-b);
  const rows = uniq.map(v => `${v}:\\; ${vals.filter(x=>x===v).length} \\text{ razy}`);
  return (
    <div style={{textAlign:'left', lineHeight:1.75}}>
      <div><strong>Krok 1 — liczymy częstości</strong></div>
      <BlockMath math={rows.join('\\\\')} />
      <div style={{marginTop:8}}><strong>Krok 2 — wskazujemy największą częstość</strong></div>
      <BlockMath math={`\\text{najczęściej występuje } ${data.modal}\\;\\Rightarrow\\; D = ${data.modal}`} />
    </div>
  );
}
